<div class="pt-4 pl-md-4 mb-6">
  <div class="row">
    <div class="col-6">
      <input type="text" class="form-control"
             placeholder="Filter event types by name"
             [(ngModel)]="filters.search"
             (ngModelChange)="handleFilterChange()">
    </div>
    <div class="col-6">
      <select class="custom-select w-auto"
              [(ngModel)]="filters.status"
              (ngModelChange)="handleFilterChange()"
              name="statusFilter" id="statusFilter">
        <option [ngValue]="EventTypeStatus.draft">Status: Draft</option>
        <option [ngValue]="EventTypeStatus.active">Status: Active</option>
        <option [ngValue]="EventTypeStatus.retired">Status: Retired</option>
      </select>
      <button routerLink="../add"
              type="button"
              class="btn btn-success float-right mb-3">
        Add Event Type
      </button>
    </div>
  </div>

  <div class="mb-3">

    <button type="button" class="btn btn-sm btn-outline-primary mb-2"
       (click)="showAllFilters = !showAllFilters; $event.preventDefault();">
      {{ showAllFilters ? 'Hide other filters' : 'Show other filters' }}
    </button>

    <div class="row" *ngIf="showAllFilters">
      <div class="col-12 col-lg-6">
        <select class="custom-select d-block mb-2"
                [(ngModel)]="filters.event_category_id"
                (ngModelChange)="handleFilterChange()"
                name="event_category_id" id="event_category_id">
          <option [ngValue]="undefined">Category: All</option>
          <option *ngIf="loadingCategories" disabled class="disabled">Loading...</option>
          <option *ngFor="let cat of categories" [ngValue]="cat.id">Category: {{ cat.name }}</option>
        </select>
      </div>
      <div class="col-12 col-lg-6">
        <select class="custom-select d-block mb-2"
                [(ngModel)]="filters.schedule_type"
                (ngModelChange)="handleFilterChange()"
                name="schedule_type" id="schedule_type">
          <option [ngValue]="undefined">Schedule Type: All</option>
          <option [ngValue]="ScheduleType.repeating">Schedule Type: Repeating</option>
          <option [ngValue]="ScheduleType.oneOff">Schedule Type: Multi-part/One-off</option>
          <option [ngValue]="ScheduleType.rolling">Schedule Type: Rolling</option>
        </select>
      </div>
      <div class="col-12 col-lg-6">
        <select class="custom-select d-block"
                [(ngModel)]="filters.location_id"
                (ngModelChange)="handleFilterChange()"
                name="location_id" id="location_id">
          <option [ngValue]="undefined">Available At Location: Any</option>
          <option *ngIf="locationService.getLocations() === null" disabled class="disabled">Loading...</option>
          <ng-container *ngIf="locationService.getLocations() !== null">
            <option *ngFor="let loc of locationService.getLocations()"
                    [ngValue]="loc.id">
              Available At Location: {{ loc.name }}
            </option>
          </ng-container>
        </select>
      </div>
    </div>

  </div>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="alert alert-info" role="alert"
       *ngIf="loadingSave">
    Loading...
  </div>

  <div class="alert alert-success" role="alert"
       *ngIf="successMessage">
    {{ successMessage }}
  </div>

  <div class="alert alert-danger" role="alert"
       *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <div class="alert alert-danger" role="alert"
       *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </div>

  <div class="rounded-table-wrapper table-responsive-lg position-relative">
    <div *ngIf="loadingEventTypes" class="loading-overlay-container rounded">
      <h1 class="loading-overlay-text">Loading...</h1>
    </div>

    <table class="table">

      <thead>
      <tr>
        <th scope="col">Event Type Name</th>
        <th scope="col">Schedule Type</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="eventTypeList && eventTypeList.results && (eventTypeList.results.length > 0)">
      <tr *ngFor="let eventType of eventTypeList.results">
        <td>{{ eventType.name }}</td>
        <td>
          {{ getScheduleTypeDisplay(eventType.schedule_type) }}
          <ng-container *ngIf="eventType.is_private_event_request_form">
            (Private Request Form)
          </ng-container>
        </td>
        <td style="padding-top: 6px; padding-bottom: 6px;">
          <div class="dropdown dropleft">
            <button class="btn btn-primary float-right dropdown-toggle"
                    style="padding-top: 3px; padding-bottom: 3px;"
                    type="button" id="manageEventTypeButton{{ eventType.id }}"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    [disabled]="loadingSave" [class.disabled]="loadingSave">
              Manage
            </button>
            <div class="dropdown-menu" attr.aria-labelledby="manageEventTypeButton{{ eventType.id }}">
              <a class="dropdown-item" href="#"
                 *ngIf="eventType.status === EventTypeStatus.draft"
                 [class.disabled]="loadingSave"
                 (click)="$event.preventDefault();activateEventType(eventType);">
                Activate
              </a>
              <a class="dropdown-item text-danger" href="#"
                 *ngIf="eventType.status === EventTypeStatus.active
                        || eventType.status === EventTypeStatus.draft"
                 [class.disabled]="loadingSave"
                 (click)="$event.preventDefault();retireEventType(eventType);">
                Retire
              </a>
              <a class="dropdown-item"
                 routerLink="../edit/{{ eventType.id }}/details">
                Edit
              </a>
              <ng-container *ngIf="eventType.status !== EventTypeStatus.draft">
                <a class="dropdown-item"
                   href="{{ climberAppEventTypeDetailsUrl(eventType) }}"
                   target="_blank">
                  View
                </a>
              </ng-container>
              <a class="dropdown-item" href="#"
                 [class.disabled]="loadingSave"
                 (click)="$event.preventDefault();duplicateEventType(eventType);">
                Duplicate
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!(eventTypeList && eventTypeList.results && (eventTypeList.results.length > 0))">
      <tr>
        <td colspan="99">
          {{ loadingEventTypes ? '' : 'No event types' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="pageNumber = 1;loadEventTypes()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Event type pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
